export interface MudancaCampo {
    before: any;
    after: any;
}

export const compareObjects = (
    before: any,
    after: any
): Record<string, MudancaCampo> => {
    if (!before || !after) return {};
    
    const changes: Record<string, MudancaCampo> = {};
    const allKeys = Array.from(new Set([...Object.keys(before || {}), ...Object.keys(after || {})]));
    
    const camposIgnorados = ['data_inicio', 'criado', 'modificado'];
    
    for (const key of allKeys) {
        if (camposIgnorados.includes(key)) {
            continue;
        }
        
        const beforeValue = before?.[key];
        const afterValue = after?.[key];
        
        if (JSON.stringify(beforeValue) !== JSON.stringify(afterValue)) {
            changes[key] = {
                before: beforeValue,
                after: afterValue
            };
        }
    }
    
    return changes;
};

export const hasChanges = (before: any, after: any): boolean => {
    const changes = compareObjects(before, after);
    return Object.keys(changes).length > 0;
};

export const formatChangesForHistory = (
    changes: Record<string, MudancaCampo>
): any => {
    const formatted: any = {};
    
    for (const [key, change] of Object.entries(changes)) {
        formatted[key] = {
            antes: change.before ?? null,
            depois: change.after ?? null
        };
    }
    
    return formatted;
};

